import { useLocation } from 'wouter';

import { NotFoundError } from './errors';

function NotFound(): null {
  const [location] = useLocation();

  throw new NotFoundError(location);
}

export default NotFound;
